export default __webpack_public_path__ + "static/media/bnr11.6c5e5e8a.jpg";